import { render, staticRenderFns } from "./PaymentArchive-page.vue?vue&type=template&id=f1780dd6&"
import script from "./PaymentArchive-page.vue?vue&type=script&lang=js&"
export * from "./PaymentArchive-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports